module.exports = __webpack_public_path__ + "img/sb.d64e9848.svg";